import { GlobalEvents } from '@highlight/ipc'
import { ASR_SEGMENT_END_EVENT } from '@shared/config/Config'
import type { ElectronRuntimeDictationSegment } from '@shared/types/electron-runtime-dictation'

/**
 * Reports a finalized ASR segment to PTT in main. A missed fire-and-forget
 * delivery delays dictation finalization until the next segment.
 */
export function reportSegmentEndToMain(
  source: number,
  segmentEndTimeStamp: number,
  dictationSegment?: ElectronRuntimeDictationSegment,
): void {
  void GlobalEvents.invoke(ASR_SEGMENT_END_EVENT, source, segmentEndTimeStamp, dictationSegment).catch((err) => {
    console.error('[AudioTranscription] Failed to deliver segment end to main:', err)
  })
}
